export default class ChatStatus { }

ChatStatus.ONLINE = 'ChatStatus.ONLINE';
ChatStatus.TYPING = 'ChatStatus.TYPING';
ChatStatus.OFFLINE = 'ChatStatus.OFFLINE';
